import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Plus as AddIcon } from "react-feather";
import Dropzone from "react-dropzone";
import ImageCropperForm, { ImageAspectRatio } from "../ImageCropperForm";
import { Button, CircularProgress } from "../libs";
import { uploadFile } from "../../../services/files";
import styles from "./style.module.css"
import { useTranslation } from "react-i18next";


interface Props {
    img?: string,
    onImageDropped?: () => void;
    onUploadImage?: () => void;
    aspectRation: ImageAspectRatio;
    setPhotoUrl: (url: string) => void;
}

const UploadImageField = (props: Props) => {
    const {t} = useTranslation(["general"]);
    const [isUploading, setIsUploading] = useState(false);
    const [isImageCropperVisible, setIsImageCropperVisible] = useState(false);
    const [currentFile, setCurrentFile] = useState<File | undefined>();
    const [tStyles, setStyles] = useState({
        minHeight: "200px",
        minWidth: "200px",
    });
    let content;

    useEffect(() => {
        setIsUploading(false);
        setIsImageCropperVisible(false);
        setCurrentFile(undefined);
        if(props.aspectRation === ImageAspectRatio.rectangle_2_2){
            setStyles({
                minHeight: "200px",
                minWidth: "200px",
            })
        }else{
            setStyles({
                minHeight: "200px",
                minWidth: "300px",
            })
        }
    }, [props.img])

    const onDrop = async (files: File[]) => {
        setCurrentFile(files[0]);
        setIsImageCropperVisible(true);
    };

    if (isUploading) {
        content = <div key='4'
                       style={{
                           ...tStyles,
                           display: "flex",
                           justifyContent: "center",
                           alignItems: "center"
                       }}
        >
            <CircularProgress
                m={2}
                color="secondary"
            />
        </div>;
    } else if (!props.img) {
        content = <Dropzone onDrop={onDrop} key='3'>
            {({ getRootProps, getInputProps }) => (
                <div {...getRootProps({ className: styles.dropzone })}
                     style={{ ...tStyles, width: "100%" }}>
                    <input {...getInputProps()} />
                    <AddIcon size={30}/>
                    <span>{t("general:load")}</span>
                </div>
            )}
        </Dropzone>
    } else {
        content = <>
            <div key='5' style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 15
            }}>
                <img
                    src={props.img}
                    alt=""
                    key={props.img}
                    style={{
                        maxWidth: "100%",
                        borderRadius: 10,
                    }}/>
            </div>

            <Dropzone onDrop={onDrop} key='6'>
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()}
                         style={{ textAlign: 'center' }}>
                        <input {...getInputProps()}  />
                        <Button color={"primary"} style={{ marginTop: -10 }}>Заменить</Button>
                    </div>
                )}
            </Dropzone>
        </>
    }

    const uploadImage = async (file: File) => {
        const res = await uploadFile(file);
        const { downloadUrl } = res;
        props.setPhotoUrl(downloadUrl);
        setIsUploading(false);
    };

    return <>
        {content}
        <ImageCropperForm
            open={isImageCropperVisible}
            close={() => {
                setIsImageCropperVisible(false)
            }}
            image={currentFile}
            uploadImage={async (file: File) => {
                await uploadImage(file);
                props.onUploadImage && props.onUploadImage();
            }}
            aspectRation={props.aspectRation}
        />
    </>
}


export default observer(UploadImageField);
